function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import find from 'lodash/find';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import Avatar from 'components/Avatar';
import BackToMainView from 'components/BackToMainView';
import Button from 'components/Form/Button';
import Statement from 'components/Statement';
import App, { AlertsBus } from 'modules/App';
import Account from 'modules/Account';
import OrganizationAdmin from 'modules/OrganizationAdmin';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import messages from '../../messages';
import Information from '../../partials/Information';
import styles from '../../OrganizationLogo.pcss';
import Admin from './Admin';
import LeaveOrganizationModal from './LeaveOrganizationModal';
var _React_PureComponent;
class OrganizationMembershipDetails extends (_React_PureComponent = React.PureComponent) {
    componentDidMount() {
        this.props.onFetchOrganizationMembershipDetails(this.organizationMembership);
    }
    componentDidUpdate(prevProps) {
        const { organizationMemberships } = this.props;
        if (!prevProps.organizationMemberships.length && organizationMemberships.length) {
            this.props.onFetchOrganizationMembershipDetails(this.organizationMembership);
        }
    }
    get identity() {
        const { identityUID } = this.organizationMembership;
        return find(this.props.identities, {
            identityUID
        });
    }
    get isLoaded() {
        const { organizationUID, organizationMembershipDetails } = this.props;
        return !!organizationMembershipDetails && organizationMembershipDetails.organizationUID === organizationUID;
    }
    get isLeaveDisabled() {
        return this.organizationMembership.isAdmin && this.organizationMembership.status === 'Active' && !this.props.adminOrganizationMemberships;
    }
    renderCountry(alpha2Code) {
        const country = find(this.props.countries, {
            alpha2Code
        });
        return get(this.props.localizationResources, [
            country.nameKey,
            'value'
        ], country.englishName);
    }
    renderLeaveOrganizationBtn() {
        if (this.isLeaveDisabled) {
            return null;
        }
        return /*#__PURE__*/ _jsx(Button, {
            styleModifier: "primary",
            labelMessage: messages.buttons.leaveOrganization,
            className: "btn--md",
            onClick: ()=>this.props.onOpenModal(constants.LEAVE_MODAL)
        });
    }
    renderLeaveOrganizationModal() {
        if (this.isLeaveDisabled) {
            return null;
        }
        return /*#__PURE__*/ _jsx(LeaveOrganizationModal, {
            organizationMembership: this.organizationMembership
        });
    }
    renderHeaderImage() {
        const { logo, name } = this.organizationMembership.organization || {};
        return /*#__PURE__*/ _jsx("figure", {
            className: "linkTile__image",
            children: /*#__PURE__*/ _jsx(Avatar, {
                avatarImg: logo,
                name: name,
                size: 48,
                className: styles.logo
            })
        });
    }
    renderHeaderContent() {
        const { organizationUID, countryCode, name, city, street, zipCode } = this.organizationMembership.organization || {};
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "linkTile__header",
                    children: name
                }),
                /*#__PURE__*/ _jsxs("p", {
                    className: "linkTile__info",
                    children: [
                        "ID: ",
                        organizationUID
                    ]
                }),
                /*#__PURE__*/ _jsxs("p", {
                    className: "linkTile__info",
                    children: [
                        this.renderCountry(countryCode),
                        ", ",
                        street,
                        ", ",
                        city,
                        " ",
                        zipCode
                    ]
                })
            ]
        });
    }
    renderHeader() {
        return /*#__PURE__*/ _jsx("header", {
            className: "pageHeader",
            children: /*#__PURE__*/ _jsx("div", {
                className: "linkTile",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "row align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-auto",
                            children: this.renderHeaderImage()
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col",
                            children: this.renderHeaderContent()
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-auto",
                            children: this.renderLeaveOrganizationBtn()
                        })
                    ]
                })
            })
        });
    }
    renderPendingInfo() {
        if (this.organizationMembership.status !== 'Pending') {
            return null;
        }
        return /*#__PURE__*/ _jsx("section", {
            className: "section section--transparent",
            children: /*#__PURE__*/ _jsx(Statement, {
                headerMessage: messages.headers.waitForAdminApproval,
                imgSrc: "/aid/assets/svg/progress.svg",
                isFullWidth: true,
                isNoShadow: true,
                children: /*#__PURE__*/ _jsx("p", {
                    className: "text--paragraph",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.waitForAdminApproval))
                })
            })
        });
    }
    renderMembershipDetails() {
        const { identity } = this;
        const { businessEmail } = this.props.organizationMembershipDetails || {};
        const { isLoaded } = this;
        return /*#__PURE__*/ _jsxs("section", {
            className: "mt-8",
            children: [
                /*#__PURE__*/ _jsx("header", {
                    className: "section__header",
                    children: /*#__PURE__*/ _jsx("h4", {
                        className: "text--h4",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.organizationMembershipInfo))
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "section form-groups pt-3",
                    children: [
                        /*#__PURE__*/ _jsx(Information, {
                            labelMessage: Account.messages.labels.email,
                            value: isLoaded && businessEmail
                        }),
                        /*#__PURE__*/ _jsx(Information, {
                            labelMessage: messages.labels.scope,
                            value: isLoaded && identity && /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, Account.messages.scopes[identity.scope]))
                        })
                    ]
                })
            ]
        });
    }
    render() {
        if (isEmpty(this.organizationMembership)) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(BackToMainView, {
                    routeName: "organization-memberships",
                    message: messages.headers.backToOrganizations
                }),
                this.renderHeader(),
                /*#__PURE__*/ _jsx(AlertsBus, {
                    className: "section section--transparent mt-5"
                }),
                /*#__PURE__*/ _jsx(Admin, {
                    organizationMembership: this.organizationMembership
                }),
                this.renderPendingInfo(),
                this.renderMembershipDetails(),
                this.renderLeaveOrganizationModal()
            ]
        });
    }
    constructor(props){
        super(props);
        const { organizationUID } = props;
        this.organizationMembership = _object_spread({}, find(this.props.organizationMemberships, {
            organizationUID
        }));
    }
}
_define_property(OrganizationMembershipDetails, "propTypes", {
    // Explicit props
    organizationUID: PropTypes.string.isRequired,
    // Implicit props
    organizationMemberships: PropTypes.arrayOf(shapes.organizationMembership),
    organizationMembershipDetails: shapes.organizationMembershipDetails,
    adminOrganizationMemberships: PropTypes.arrayOf(OrganizationAdmin.shapes.organizationMembership),
    identities: PropTypes.arrayOf(Account.shapes.identity),
    countries: PropTypes.arrayOf(App.shapes.country),
    localizationResources: PropTypes.object,
    // Implicit actions
    onFetchOrganizationMembershipDetails: PropTypes.func,
    onOpenModal: PropTypes.func
});
const mapStateToProps = (state)=>({
        organizationMemberships: selectors.organizationMemberships(state),
        organizationMembershipDetails: selectors.organizationMembershipDetails(state),
        adminOrganizationMemberships: OrganizationAdmin.selectors.organizationMemberships(state),
        identities: Account.selectors.identities(state),
        countries: App.selectors.countries(state),
        localizationResources: App.selectors.localizationResources(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onFetchOrganizationMembershipDetails: (organizationMembership)=>dispatch(actions.fetchOrganizationMembershipDetails(organizationMembership)),
        onOpenModal: (modalId)=>dispatch(App.actions.openModal(modalId))
    });
const ConnectedOrganizationMembershipDetails = connect(mapStateToProps, mapDispatchToProps)(OrganizationMembershipDetails);
export default withStyles(styles)(ConnectedOrganizationMembershipDetails);
